import styled from 'styled-components'
import { VerticalStyledScrollBar } from '~/styles'

export const TimelineContainer = styled.section.attrs(props => ({
  scrollbarBackground: props.theme.colors.colorf3f5f9
}))`
  position: relative;
  width: 100%;
  height: 100%;
  padding-bottom: 6vh;

  display: flex;
  flex-direction: column;
  gap: 0.5rem;

  overflow-y: auto;
  ${VerticalStyledScrollBar}
`
